import { graphql } from '../../gql';

export default graphql(`
    mutation CreateUserToken($input: CreateUserTokenInput!) {
        createUserToken(input: $input) {
            token
        }
    }
`);
